import { render, staticRenderFns } from "./ShareFlowModal.vue?vue&type=template&id=4c5a3af6&scoped=true"
import script from "./ShareFlowModal.vue?vue&type=script&lang=js"
export * from "./ShareFlowModal.vue?vue&type=script&lang=js"
import style0 from "./ShareFlowModal.vue?vue&type=style&index=0&id=4c5a3af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5a3af6",
  null
  
)

export default component.exports